<template>
  <div class="flex flex-col items-center gap-24">
    <h2 class="text-static-default-hi heading-2 text-center">
      {{ i18n(translations.sectionTitle) }}
    </h2>
    <TradeInSearchBar
      class="w-full md:w-[380px]"
      :displayDefaultOption="false"
      :displaySelectExample="false"
      zone="buyback-pp-search"
      @item-selected="handleItemSelected"
    />
  </div>
</template>

<script setup lang="ts">
import type { BuybackProduct } from '@backmarket/nuxt-layer-buyback/app/scopes/offer/api/types'
import TradeInSearchBar from '@backmarket/nuxt-layer-buyback/app/scopes/offer/components/TradeInSearchBar/TradeInSearchBar.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './SeoSearchBar.translations'

const i18n = useI18n()

const emit = defineEmits<{
  (e: 'item-selected', item: BuybackProduct): void
}>()

function handleItemSelected(item: BuybackProduct) {
  emit('item-selected', item)
}
</script>
